import { NonProductionDayType } from "us.collection.admin/constants";

export const NonProductionDayTabs = [
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_PRINTING_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_DOCUMENT_DOES_NOT_PRINT",
    type: NonProductionDayType.Non_Printing,
  }, 
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_SMS_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_SMS_DOES_NOT_SENT",
    type: NonProductionDayType.Non_SMS,
  },
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_EMAIL_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_EMAIL_DOES_NOT_SENT",
    type: NonProductionDayType.Non_Email,
  },
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_EHF_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_EHF_DOES_NOT_SENT",
    type: NonProductionDayType.Non_EHF,
  },
];
